import React, { useState } from "react";
import { i18n } from '../../lang/i18n';
import UserLoginScreen from "../Customer/Login/UserLoginScreen";
import { NavLink, useNavigate } from "react-router-dom";
import CartDeliveryStepAddress from "./CartDeliveryStepAddress";
import CartDeliveryStepProducts from "./CartDeliveryStepProducts";
import CartDeliveryStepPayment from "./CartDeliveryStepPayment";
import './TabCartDelivery.css';
import { useAppSelector } from "../../store/hooks";

export default function TabCartDelivery()
{
    const cart = useAppSelector((state) => state.cart)
    const userData = useAppSelector((state) => state.userData)
    const navigate = useNavigate();
    const [step, setStep] = useState(1)
    const [loginActive, setLoginActive] = useState(true);

    function renderNoProducts()
    {
        return (<div className="view-cart">
            <div className="main-subtitle">
                <h3>{i18n.ViewCart.CartTitle}</h3>
            </div>
            <div className="box text-center pt-5 pb-5"><p>{i18n.ViewCart.NoProducts}</p></div>
            <div className="box">
                <br />
                <div className="container main-subtitle mt-1">
                    <NavLink to="/" className="btn-back link-btn"> <i className="fa fa-home" />{i18n._Labels.SeeProducts}</NavLink>
                </div>
                <br />
            </div>
        </div>)
    }

    function onLoginClose()
    {
        navigate('/')
        setLoginActive(false)
    }

    function renderWithoutLogin()
    {
        if (userData.isActive) return null
        if (loginActive)
            return <div className="tab-cart">
                <div className="tab-cart-body">
                    <div className="main-subtitle">
                        <h3>{i18n.TabCart.LetRegisterFirst}</h3>
                    </div>
                    <div>
                        <div className="p-3 text-center">
                            <p>{i18n.TabCart.LetRegisterFirst_Line1}</p>
                            <p>{i18n.TabCart.LetRegisterFirst_Line2}</p>
                        </div>
                        <UserLoginScreen />
                    </div>
                    <div style={{ padding: 10, paddingBottom: 40 }}>
                        <button className="btn btn-cancel" style={{ minWidth: 300 }}
                            onClick={onLoginClose}
                        >{i18n._BTNs.Cancel}</button>
                    </div>
                </div>
            </div>
        return <></>
    }

    if (cart.totalProducts === 0)
        return renderNoProducts()

    return (<div className="p-3">
        {userData.isActive && <>
            <div className="row">
                <div className='col-12 mt-4 text-center'>
                    <h2>{i18n.TabCartDelivery.Title}</h2>
                </div>
            </div>
            <div className="row cart-step">
                <div className='col-12 mt-4' onClick={() => { if (step > 1) setStep(1) }}>
                    <h3 className={step === 1 ? 'cart-step-title-active' : ''}>{i18n.CartDeliveryStepProducts.Title}</h3>
                </div>
                <div className='col-12 cart-step-body' >
                    <CartDeliveryStepProducts isReady={step > 1} onStepContinue={() => { setStep(2); setLoginActive(true) }} />
                </div>
            </div>
            <div className="row cart-step">
                <div className='col-12 mt-4' onClick={() => { if (step > 2) setStep(2) }}>
                    <h3 className={step === 2 ? 'cart-step-title-active' : ''}>{i18n.CartDeliveryStepAddress.Title}</h3>
                </div>
                {step >= 2 && <div className='col-12 cart-step-body' >
                    <CartDeliveryStepAddress isReady={step > 2} onStepContinue={() => { setStep(3); }} />
                </div>}
            </div>
            <div className="row cart-step">
                <div className='col-12 mt-4'>
                    <h3 className={step === 3 ? 'cart-step-title-active' : ''}>{i18n.CartDeliveryStep3.Title}</h3>
                </div>
                {step === 3 && <div className='col-12 cart-step-body' >
                    <CartDeliveryStepPayment onStepContinue={() => setStep(1)} />
                </div>}
            </div>
        </>}
        {renderWithoutLogin()}
        <br /><br />
    </div>
    )
}